// React
import React from 'react'
import classNames from 'classnames'
// Material UI
import { TimePicker } from '@material-ui/pickers'
// Styles
import useStyles from './CustomTimePicker.styles'

const CustomTimePicker = ({
  ampm,
  classes,
  inputVariant,
  label,
  margin,
  onChange,
  value,
  fullWidth,
}) => {
  const componentClasses = useStyles()
  return (
    <TimePicker
      fullWidth={fullWidth}
      ampm={ampm}
      classes={{}}
      InputProps={{
        classes: {
          input: classNames(
            componentClasses.inputPropsInput,
            classes.inputPropsInput,
          ),
          notchedOutline: classNames(
            componentClasses.inputPropsNotchedOutline,
            classes.inputPropsNotchedOutline,
          ),
          root: classNames(
            componentClasses.inputPropsRoot,
            classes.inputPropsRoot,
          ),
        },
      }}
      inputVariant={inputVariant}
      margin={margin}
      label={label}
      value={value}
      onChange={onChange}
    />
  )
}

CustomTimePicker.defaultProps = {
  ampm: false,
  classes: {},
  inputVariant: 'outlined',
  margin: 'none',
  onChange: () => {},
  value: new Date(),
  fullWidth: false,
}

export default CustomTimePicker
